import "../CampusTitle/CampusTitle.scss"

const CampusTitle = ({title}) => {
  return (
    <>
    <div className='campus-title-container'><h2 style={{paddingBottom:(title === "Scholarship") && "0"}}>{title}</h2></div>
    </>
  )
}

export default CampusTitle